import React, { createContext, useContext, useState } from 'react';

const ChatContext = createContext(undefined);

export const ChatProvider = ({ children }) => {
    const [chatUser, setChatUser] = useState(null);
    return (
        <ChatContext.Provider value={{ chatUser, setChatUser }}>
            {children}
        </ChatContext.Provider>
    );
};

export const useChat = () => {
    const ctx = useContext(ChatContext);
    if (!ctx) throw new Error('useChat must be used within ChatProvider');
    return ctx;
};
